"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _upgradeCatalogApi = require("self-service-api/core/api/upgradeCatalogApi");

var _productsAdapter = _interopRequireDefault(require("self-service-api/adapters/productsAdapter"));

var getProducts = function getProducts() {
  return _upgradeCatalogApi.upgradeCatalogApi.get().then(_productsAdapter.default);
};

var _default = getProducts;
exports.default = _default;
module.exports = exports.default;